// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-26ZV5","emojy":"emojy-9LfZv","title":"title-3UB_v"};